var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdk-contents"},[_c('h1',{staticClass:"down-title"},[_vm._v("SDK 다운로드")]),_vm._v(" "),_c('div',{staticClass:"sdk-down-box"},[_c('h3',{staticClass:"sdk-box-tag"},[_vm._v("VaRoon SDK 1.1")]),_vm._v(" "),_c('button',{staticClass:"sdk-box-btn",on:{"click":_vm.showImpossible}},[_vm._v("Download")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c4d6568","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SellerManager/SDKDownload.vue
// module id = 209
// module chunks = 0